
const ConsultTabStyles = theme => ({
    consultWrapper: {
        display: "flex",
        flex: 1,
        flexDirection: "column",
    },
    tableWrapper: {
        display: "flex",
        width: "100%",
        flexShrink: 0
    },
    questionsWrapper: {
        display: "flex",
        width: "100%",
        flexDirection: "column",
        position: "relative",
        overflow: "auto",

    },
    questionsProductWrapper: {
        display: "flex",
        width: "100%",
        flexDirection: "column",
        position: "relative",
    },
    questionsHeaderAndTitleWrapper: {
        display: "flex",
        width: "100%",
        flexDirection: "column",
        position: "relative"
    },
    questionsTitleWrapper: {
        display: "flex",
        width: "100%",
        backgroundColor: "#eef1f1",
        minHeight: 35,
        alignItems: "center"
    },
    consultationTitle: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "16px",
        fontWeight: "bold",
        letterSpacing: 0,
        lineHeight: "20px",
        width: "70%",
        padding: "0px 20px"
    },
    consultationAnswerTitle: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "16px",
        fontWeight: "bold",
        letterSpacing: 0,
        lineHeight: "20px",
        display: "flex",
        flex: 1,
        paddingRight: "20px"
    },
    questionsRowWrapper: {
        display: "flex",
        flexShrink: 0,
        paddingTop: 6.5,
        paddingBottom: 6.5,
        alignItems: "center",
        width: "100%",
        borderBottom: "2px solid #ededed",
        backgroundColor: "#ffffff"
    },
    questionsRowWrapperOddRow: {
        display: "flex",
        flexShrink: 0,
        paddingTop: 6.5,
        paddingBottom: 6.5,
        alignItems: "center",
        borderBottom: "2px solid #ededed",
        width: "100%",
        backgroundColor: "#fafafa"
    },
    tableRowWrapper: {
        display: "flex",
        marginTop: 13,
        flexShrink: 0,
        flexDirection: "column"
    },
    tableHeaderTitle: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "16px",
        display: "flex",
        minHeight: 35,
        alignItems: "center",
        fontWeight: "bold",
        letterSpacing: "0",
        paddingLeft: 20,
        lineHeight: "20px",
        backgroundColor: "#eef1f1"
    },
    iconHeader: {
        paddingLeft: "0px !important",
        minWidth: 17,
        paddingRight: "0px !important"
    },
    tableRow: {
        display: "flex",
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: 14,
        letterSpacing: "0",
        lineHeight: "24px",
        maxHeight: 24,
        paddingLeft: 20,
        marginBottom: 13
    },
    tableRowEllipsis: {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "inline-block !important"
    },
    editIconWrapper: {
        display: "flex",
        flexDirection: "column"
    },
    tableCenter: {
        justifyContent: "center"
    },
    tableRowBold: {
        fontWeight: "bold"
    },
    orderDateStyle: {
        minWidth: 87,
        display: "flex",
        flexDirection: "column"
    },
    orderNumberStyle: {
        minWidth: 116,
        display: "flex",
        flexDirection: "column"
    },
    productStyle: {
        display: "flex",
        flex: 1,
        flexDirection: "column"
    },
    editIcon: {
        minHeight: 14,
        maxHeight: 14,
        minWidth: 14,
        maxWidth: 14,
        cursor: "pointer"
    },
    imageWrapper: {
        minHeight: 24,
        marginBottom: 13,
        display: "flex",
        alignItems: "center"
    },
    qty: {
        display: "flex",
        minWidth: 28,
        flexDirection: "column"
    },
    orderType: {
        display: "flex",
        flexDirection: "column"
    },
    status: {
        display: "flex",
        flexDirection: "column"
    },

    checkbox: {
        padding: 0,
        marginRight: 5,
        color: "#00c469 !important"
    },
    disabledCheckbox: {
        padding: 0,
        marginRight: 5,
        color: "grey !important"
    },
    modal: {
        display: 'flex',
        alignItems: 'center',
    },
    modalBody: {
        display: "flex",
        position: "relative",
        backgroundColor: "white",
        flexDirection: "column",
        outline: "none",
        overflow: "hidden",
    },
    modalHeader: {
        maxHeight: 24,
        display: "flex",
        flex: 1,
        backgroundColor: "#d2dcdd",
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: 16,
        fontWeight: "bold",
        letterSpacing: 0,
        lineHeight: "20px",
        paddingLeft: 13,
        alignItems: "center"
    },
    productInput: {
        flexGrow: 1,
        height: 27,
        "& > div": {
            height: 27,
            border: "1px solid #979797",
            borderRadius: 3
        },
        "& fieldset": {
            display: "none"
        },
        "& div": {
            color: "#242424",
            fontFamily: "Proxima Nova",
            fontSize: "14px",
            letterSpacing: 0,
            backgroundColor: "white",
            lineHeight: "17px"
        },
        "& div:focus": {
            backgroundColor: "white !important",
        }
    },
    productSelectStyle: {
        padding: 0,
        paddingLeft: 10
    },
    menuItemRoot: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "14px",
        letterSpacing: 0,
        lineHeight: "17px"
    },
    menuItemSelected: {
        backgroundColor: "#f3fdfd !important"
    },
    modalContentWrapper: {
        display: "flex",
        flex: 1,
        flexDirection: "column",
        paddingLeft: 17,
        paddingRight: 17,
        paddingBottom: 17,
    },
    productSelectWrapper: {
        display: "flex",
        marginTop: 22,
        alignItems: "center"
    },
    productText: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "14px",
        letterSpacing: 0,
        lineHeight: "17px",
        width: 80,
        fontWeight: "bold",
    },
    menuItemWidth: {
        minWidth: 452,
        maxWidth: 452
    },
    menuItemList: {
        "& li": {
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "inline-block",
            width: "100%"
        }
    },
    statusStyle: {
        paddingRight: 20
    },
    errorWrapper: {
        color: "#E12929",
        fontFamily: "Proxima Nova",
        fontSize: "12px",
        letterSpacing: 0,
        lineHeight: "15px",
        minHeight: 16,
        marginLeft: 80,
        marginTop: 3
    },
    qtyWrapper: {
        marginTop: 16,
        display: "flex",
        alignItems: "center"
    },
    qtyNumberField: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "14px",
        letterSpacing: 0,
        backgroundColor: "white",
        lineHeight: "17px",
        width: 40,
        height: 23,
        border: "1px solid #979797",
        borderRadius: 5,
        textAlign: "center",
        outline: "none"
    },
    reasonForChangeWrapper: {
        marginTop: 16
    },
    reasonForChangeText: {
        width: "auto !important"
    },
    reasonForChangeTextArea: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "14px",
        letterSpacing: 0,
        backgroundColor: "white",
        lineHeight: "17px",
        width: "100%",
        height: 120,
        border: "1px solid #979797",
        resize: "none",
        marginTop: 3,
        boxSizing: "border-box",
        outline: "none",
        padding: 10
    },
    buttonStyle: {
        boxShadow: 'none',
        width: 150,
        height: 30,
        textTransform: 'none',
        fontSize: 16,
        lineHeight: "20px",
        padding: 0,
        marginRight: 20,
        fontWeight: "bold",
        backgroundColor: '#00ad50',
        fontFamily: "Proxima Nova",
        '&:hover': {
            backgroundColor: '#00ad50',
            boxShadow: 'none',
        },
        '&:active': {
            backgroundColor: '#00ad50',
            boxShadow: 'none',
        },
        '&:focus': {
            backgroundColor: '#00ad50',
            boxShadow: 'none',
        },
        '&:disabled': {
            color: 'white',
            boxShadow: 'none',
        },
    },
    cancelButtonStyle: {
        boxShadow: 'none',
        width: 108,
        height: 30,
        textTransform: 'none',
        fontSize: 16,
        lineHeight: "20px",
        padding: 0,
        border: "1px solid #4d4d4d",
        color: "#242424",
        fontWeight: "bold",
        backgroundColor: 'white',
        fontFamily: "Proxima Nova",
        '&:hover': {
            backgroundColor: 'white',
            boxShadow: 'none',
        },
        '&:active': {
            backgroundColor: 'white',
            boxShadow: 'none',
        },
        '&:focus': {
            backgroundColor: 'white',
            boxShadow: 'none',
        },
    },
    modalActionWrapper: {
        display: "flex",
        flex: 1,
        justifyContent: "flex-end",
        alignItems: "flex-end",
        marginTop: 40
    },
    qtySelect: {
        width: 80,
        height: 27,
        "& > div": {
            height: 27,
            border: "1px solid #979797",
            borderRadius: 3
        },
        "& fieldset": {
            display: "none"
        },
        "& div": {
            color: "#242424",
            fontFamily: "Proxima Nova",
            fontSize: "14px",
            letterSpacing: 0,
            backgroundColor: "white",
            lineHeight: "17px"
        },
        "& div:focus": {
            backgroundColor: "white !important",
        }
    },
    qtyMenuItemWidth: {
        minWidth: 80,
        maxWidth: 80
    },
    redRow: {
        color: "#FF0000 !important"
    },
    consultationQuestionRow: {
        color: "#242424",
        padding: "0px 20px",
        fontFamily: "Proxima Nova",
        fontSize: 14,
        letterSpacing: 0,
        lineHeight: "17px",
        width: "70%"
    },
    noConsultData: {
        color: "#242424",
        padding: "0px 20px",
        fontFamily: "Proxima Nova",
        fontSize: 14,
        letterSpacing: 0,
        lineHeight: "17px",
        marginTop: 16,
    },
    consultationAnswerRow: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: 14,
        letterSpacing: 0,
        lineHeight: "17px",
        width: "30%",
        whiteSpace: "pre-wrap"
    },
    disabledEditIcon: {
        cursor: "default !important"
    },
    linkUploadedFiles: {
        color: "#00AD50",
        fontFamily: "Proxima Nova",
        fontSize: "14px",
        lineHeight: "initial",
        borderBottom: "1px solid",
        cursor: "pointer"
    },
    pdfViewLinkColumn: {
        display: "flex",
        flexShrink: "0",
        flexDirection: "unset"
    },
    uploadedPdfLink: {
        color: "#00AD50",
        cursor: "pointer",
        fontSize: "16px",
        fontFamily: "Proxima Nova",
        lineHeight: "initial",
        borderBottom: "1px solid",
        marginLeft: "2vh",
        marginBottom: "2vh",
        fontWeight: 800
    }
})

export default ConsultTabStyles;